
<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransform()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
           
                <div style="display: flex;margin-top:-10px;margin-left: -3px;"><app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
         

            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        <mat-expansion-panel class="mat-elevation-z0" >
            <mat-expansion-panel-header>Advanced Settings<span *ngIf="isValidateAdvanceSettings" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="margin-top: -10px;margin-left: -2px;margin-bottom: 10px;">
                <mat-form-field [formGroup]="form">
                    <mat-label>{{threads.label}}</mat-label>
                    <input matInput formControlName="threads" type="number" placeholder="Threads" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                </mat-form-field>
            </div>
            <div>Fixed Preserved Terms</div>
            <div>
                <table class="table-like-mat">
                    <!-- Header Row -->
                     <thead>
                        <th style="width: 15%;"> Type </th>
                        <th style="width: 45%;"> Preserved Terms </th>
                        <th style="width: 15%;"> Load Preset </th>
                        <th style="width: 10%;"> Delete </th>
                        <th style="width: 15%;"> Match Case </th>
                    </thead>
                    <tr>
                        <td>{{fixedTermsName.label}}</td>
                        <td style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFixedPreservedCellClicked(viewModel.fixedTermsName,'Name')">
                            <span *ngIf="viewModel.fixedTermsName?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Preserved Terms</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of viewModel.fixedTermsName" [style.color]="containItem.color.color">{{containItem.text }}</span>
                        </td>
                        <td style="text-align: center;"><img src="assets/images/download_default.png" alt="Download Defaults" class="download-default" (click)="onLoadreset('Name')"/></td>
                        <td style="text-align: center;"><mat-icon class="delete-all" (click)="onDelete('Name')">delete_sweep</mat-icon></td>
                        <td style="text-align: center;"><mat-slide-toggle color="primary" [(ngModel)]="viewModel.caseName"></mat-slide-toggle></td>
                    </tr>
                    <tr>
                        <td>{{fixedTermsCategory.label}}</td>
                        <td style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFixedPreservedCellClicked(viewModel.fixedTermsCategory,'Category')">
                            <span *ngIf="viewModel.fixedTermsCategory?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Preserved Terms</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of viewModel.fixedTermsCategory" [style.color]="containItem.color.color">{{containItem.text }}</span>
                        </td>
                        <td style="text-align: center;"><img src="assets/images/download_default.png" alt="Download Defaults" class="download-default" (click)="onLoadreset('Category')"/></td>
                        <td style="text-align: center;"><mat-icon class="delete-all" (click)="onDelete('Category')">delete_sweep</mat-icon></td>
                        <td style="text-align: center;"><mat-slide-toggle color="primary" [(ngModel)]="viewModel.caseCategory"></mat-slide-toggle></td>
                    </tr>
                    <tr>
                        <td>{{fixedTermsLocation.label}}</td>
                        <td style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFixedPreservedCellClicked(viewModel.fixedTermsLocation,'Location')">
                            <span *ngIf="viewModel.fixedTermsLocation?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Preserved Terms</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of viewModel.fixedTermsLocation" [style.color]="containItem.color.color">{{containItem.text }}</span>
                        </td>
                        <td style="text-align: center;"><img src="assets/images/download_default.png" alt="Download Defaults" class="download-default" (click)="onLoadreset('Location')"/></td>
                        <td style="text-align: center;"><mat-icon class="delete-all" (click)="onDelete('Location')">delete_sweep</mat-icon></td>
                        <td style="text-align: center;"><mat-slide-toggle color="primary" [(ngModel)]="viewModel.caseLocation"></mat-slide-toggle></td>
                    </tr>
                    <tr>
                        <td>{{fixedTermsDetails.label}}</td>
                        <td style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFixedPreservedCellClicked(viewModel.fixedTermsDetails,'Details')">
                            <span *ngIf="viewModel.fixedTermsDetails?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Preserved Terms</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of viewModel.fixedTermsDetails" [style.color]="containItem.color.color">{{containItem.text }}</span>
                        </td>
                        <td style="text-align: center;"><img src="assets/images/download_default.png" alt="Download Defaults" class="download-default" (click)="onLoadreset('Details')"/></td>
                        <td style="text-align: center;"><mat-icon class="delete-all" (click)="onDelete('Details')">delete_sweep</mat-icon></td>
                        <td style="text-align: center;"><mat-slide-toggle color="primary" [(ngModel)]="viewModel.caseDetails"></mat-slide-toggle></td>
                    </tr>
                    <tr>
                        <td>{{fixedTermsURL.label}}</td>
                        <td style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFixedPreservedCellClicked(viewModel.fixedTermsURL,'URL')">
                            <span *ngIf="viewModel.fixedTermsURL?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Preserved Terms</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of viewModel.fixedTermsURL" [style.color]="containItem.color.color">{{containItem.text }}</span>
                        </td>
                        <td style="text-align: center;"><img src="assets/images/download_default.png" alt="Download Defaults" class="download-default" (click)="onLoadreset('URL')"/></td>
                        <td style="text-align: center;"><mat-icon class="delete-all" (click)="onDelete('URL')">delete_sweep</mat-icon></td>
                        <td style="text-align: center;"><mat-slide-toggle color="primary" [(ngModel)]="viewModel.caseURL"></mat-slide-toggle></td>
                    </tr>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 30px;">Rules</span>

                    <button class="add-rule-btn" 
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule" style="height: 24px;border-radius: 2px;">
                        <mat-icon >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                         color="primary"
                        mat-raised-button title="Show All"  class="rule-toggle-btn"  style=" line-height: 24px;height: 24px;border-radius: 2px;">
                        <mat-icon >{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                        <!-- {{isRulesMaximized ? 'MINIMIZE' : 'MAXIMIZE'}} -->
                    </button>

                </div>

            </mat-expansion-panel-header>

            <!--  [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div
                style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">

                            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                               <!--<mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" class="icon" (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">control_point_duplicate</mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>-->
                                <mat-icon color="primary"
                                style="cursor: grab" 
                                cdkDrag [cdkDragData]="rule"
                                cdkDragRootElement=".drag-component"
                                cdkDragHandle
                                matTooltip="Re-order Rule"  
                                matTooltipPosition="below"
                                #reorderTooltip="matTooltip"
                                (mouseenter)="reorderTooltip.show()"
                                (mouseleave)="reorderTooltip.hide()"
                                >reorder</mat-icon>
    
                                <mat-icon style="margin-left: 4px; cursor: pointer" 
                                class="icon" 
                                (click)="onDuplicateRule(rule)" 
                                matTooltip="Duplicate Rule" 
                                matTooltipPosition="below"
                                #duplicateTooltip="matTooltip"
                                (mouseenter)="duplicateTooltip.show(); 
                                reorderTooltip.hide()"
                                (mouseleave)="duplicateTooltip.hide()"
                                color="primary">
                                control_point_duplicate
                               </mat-icon>
                               <mat-icon style="margin-left: 2px; cursor: pointer"
                                (click)="onDeleteRule(rule)" 
                                matTooltip="Delete Rule" 
                                matTooltipPosition="below"
                                #deleteTooltip="matTooltip"
                                (mouseenter)="deleteTooltip.show(); duplicateTooltip.hide(); reorderTooltip.hide()"
                                (mouseleave)="deleteTooltip.hide()"
                                class="red-icon">
                                delete_forever
                            </mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Rule Name </th>
                        <td mat-cell *matCellDef="let rule">
                            <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.ruleName" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="anonType">
                        <th mat-header-cell *matHeaderCellDef style="width: 130px;"> Anonymizer Type </th>
                        <td mat-cell *matCellDef="let rule" style="width: 130px;">
                            <mat-select [(value)]="rule.anonType" style="color: #99ff00;" (selectionChange)="onAnonTypeChange(rule)">
                                <mat-select-trigger>
                                    <span style="color: #99ff00">{{AnonTypeUtil.toString(rule.anonType)}}</span>
                                </mat-select-trigger>
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let ruleType of AnonTypes" [value]="ruleType">
                                    {{AnonTypeUtil.toString(ruleType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="fields">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ff9f0c;"> Fields Selected </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;border-left: 1px solid #ff9f0c;" class="fixed-width-column text-overflow"
                            (click)="onRuleFieldSelectCellClicked(rule)">
                            <span *ngIf="rule.fields?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of rule.fields"
                                [style.color]="containItem.color.color">{{containItem.text }} </span>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="preservedTerms">
                        <th mat-header-cell *matHeaderCellDef class="fixed-width-column"> Preserved terms/<br> Extensions </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;" class="fixed-width-column text-overflow"
                            (click)="!isDisabledType(rule.anonType) && onRulePreservedCellClicked(rule)">
                            <!-- Show <NA> if the anonType is restricted -->
                            <ng-container *ngIf="isDisabledType(rule.anonType); else editableContent">
                                <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                    &lt;NA&gt;
                                </span>
                            </ng-container>

                            <!-- Else show "Tap to Edit" or preserved terms -->
                            <ng-template #editableContent>
                                <span *ngIf="rule.preservedTerms?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                    *ngFor="let containItem of rule.preservedTerms"
                                    [style.color]="containItem.color.color">{{containItem.text }} </span>
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="mapTerms">
                        <th mat-header-cell *matHeaderCellDef class="fixed-width-column"> Map (from > to) </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;" class="fixed-width-column text-overflow"
                            (click)="onFindReplaceCellClicked(rule)">
                            <span *ngIf="rule.mapTerms?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Find > Replace</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of rule.mapTerms" [style.color]="containItem.color.color">{{containItem.find }} > {{containItem.replace}} </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ruleOption">
                        <th mat-header-cell *matHeaderCellDef style="width: 130px;"> Options </th>
                        <td mat-cell *matCellDef="let rule" style="width: 130px;">
                            <ng-container *ngIf="rule.anonType === AnonType.Name; else joinID">
                                <mat-select [(value)]="rule.ruleOption">
                                    <mat-option *ngFor="let ruleOption of RuleOptionsLocation" [value]="ruleOption">
                                    {{ RuleOptionsUtil.toString(ruleOption) }}
                                    </mat-option>
                                </mat-select>
                            </ng-container>
                            <ng-template #joinID>
                                <ng-container *ngIf="rule.anonType === AnonType.JoinID; else Location">
                                    <mat-select [(value)]="rule.ruleOption">
                                        <mat-option *ngFor="let ruleOption of RuleOptionsJoinID" [value]="ruleOption">
                                        {{ RuleOptionsUtil.toString(ruleOption) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #Location>
                                <ng-container *ngIf="rule.anonType === AnonType.Location; else Date">
                                    <mat-select [(value)]="rule.ruleOption">
                                        <mat-option *ngFor="let ruleOption of RuleOptionsLocation" [value]="ruleOption">
                                        {{ RuleOptionsUtil.toString(ruleOption) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #Date>
                                <ng-container *ngIf="rule.anonType === AnonType.Date; else Time">
                                    <mat-select [(value)]="rule.ruleOption">
                                        <mat-option *ngFor="let ruleOption of RuleOptionsDate" [value]="ruleOption">
                                        {{ RuleOptionsUtil.toString(ruleOption) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #Time>
                                <ng-container *ngIf="rule.anonType === AnonType.Time; else other">
                                    <mat-select [(value)]="rule.ruleOption">
                                        <mat-option *ngFor="let ruleOption of RuleOptionsTime" [value]="ruleOption">
                                        {{ RuleOptionsUtil.toString(ruleOption) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #other>
                                <ng-container *ngIf="rule.anonType === AnonType.Details || rule.anonType === AnonType.Category || rule.anonType === AnonType.URL; else showNA">
                                    <mat-select [(value)]="rule.ruleOption">
                                        <mat-option *ngFor="let ruleOption of RuleOptionsOther" [value]="ruleOption">
                                        {{ RuleOptionsUtil.toString(ruleOption) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #showNA>
                                <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                    &lt;NA&gt;
                                </span>
                            </ng-template>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="wordSepMode">
                        <th mat-header-cell *matHeaderCellDef style="width: 130px;"> Separator </th>
                        <td mat-cell *matCellDef="let rule" style="width: 130px;">
                            <ng-container *ngIf="(rule.anonType === AnonType.Details || rule.anonType === AnonType.Category || rule.anonType === AnonType.URL); else Name">
                                <mat-select [(value)]="rule.wordSepMode">
                                    <mat-option *ngFor="let wordSepMode of WordSepModes" [value]="wordSepMode">
                                    {{ WordSepModeUtil.toString(wordSepMode) }}
                                    </mat-option>
                                </mat-select>
                            </ng-container>
                            <ng-template #Name>
                                <ng-container *ngIf="rule.anonType === AnonType.Name; else Time">
                                    <mat-select [(value)]="rule.wordSepMode">
                                        <mat-option *ngFor="let wordSepMode of WordSepModesName" [value]="wordSepMode">
                                        {{ WordSepModeUtil.toString(wordSepMode) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                             <ng-template #Time>
                                <ng-container *ngIf="rule.anonType === AnonType.Time; else showNA">
                                    <mat-select [(value)]="rule.wordSepMode">
                                        <mat-option *ngFor="let wordSepMode of WordSepModesTime" [value]="wordSepMode">
                                        {{ WordSepModeUtil.toString(wordSepMode) }}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #showNA>
                                <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                    &lt;NA&gt;
                                </span>
                            </ng-template>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="mapOnly">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 100px;">
                            <div style="margin-bottom: 2px;">Map Only</div>
                            <mat-slide-toggle
                                (change)="onMapOnlyChanged($event)"
                                color="primary">
                            </mat-slide-toggle>
                        </th>
                    
                        <td mat-cell *matCellDef="let rule" style="text-align: center;width: 100px;">
                            <mat-slide-toggle
                                color="primary"
                                [(ngModel)]="rule.mapOnly">
                            </mat-slide-toggle>
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="matchCase">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 100px;">
                            <div style="margin-bottom: 2px;">Match Case</div>
                            <mat-slide-toggle
                                (change)="onMatchCaseChanged($event)"
                                color="primary">
                            </mat-slide-toggle>
                        </th>
                    
                        <td mat-cell *matCellDef="let rule" style="text-align: center;width: 100px;">
                            <mat-slide-toggle
                                color="primary"
                                [(ngModel)]="rule.matchCase">
                            </mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="findTerms">
                        <th mat-header-cell *matHeaderCellDef class="fixed-width-column" style="border-left: 1px solid #ff9f0c;"> In rows that contain </th>
                        <td mat-cell *matCellDef="let rule" style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onRuleFindTermsCellClicked(rule)" style="border-left: 1px solid #ff9f0c;">
                            <span *ngIf="rule.findTerms?.length === 0"
                            style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                *ngFor="let containItem of rule.findTerms"
                                [style.color]="containItem.color.color">{{containItem.text }} </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="andOr">
                        <th mat-header-cell *matHeaderCellDef style="width: 130px;"> AND/OR </th>
                        <td mat-cell *matCellDef="let rule" style="width: 130px;">
                            <mat-select [(value)]="rule.andOr">
                                <mat-select-trigger>
                                    {{AndOrUtil.toString(rule.andOr)}}
                                </mat-select-trigger>
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let andOr of AndOrTypes" [value]="andOr">
                                    {{AndOrUtil.toString(andOr)}}
                                </mat-option>
                            </mat-select>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 100px;">
                            <div style="margin-bottom: 2px;">Run</div>
                            <mat-slide-toggle
                                (change)="onRunChanged($event)"
                                color="primary">
                            </mat-slide-toggle>
                        </th>
                    
                        <td mat-cell *matCellDef="let rule" style="text-align: center;width: 100px;">
                            <mat-slide-toggle
                                color="primary"
                                [(ngModel)]="rule.run">
                            </mat-slide-toggle>
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="sampleHits">
                        <th style="border-left: 1px solid #ff9f0c;text-align: center;" mat-header-cell *matHeaderCellDef> Sample Row Hits
                        </th>
                        <td style="border-left: 1px solid #ff9f0c;text-align: center;" mat-cell *matCellDef="let rule"> {{rule.sampleHits |
                            number}} </td>
                    </ng-container>

                    <ng-container matColumnDef="hits">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Total Row Hits </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.hits | number}} </td>
                    </ng-container> -->

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <!--<tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
                <tr
                class="drag-component"
                mat-row
                *matRowDef="let row; columns: displayedColumns;"
                (click)="onRowClicked($event, row)"
                [ngClass]="{'highlight-row': selectedRows.includes(row)}">
                </tr>


                    <div *cdkDragPlaceholder></div>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setAnonymizerResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setAnonymizerPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"   ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>